module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ehrendingen-b371a54bfc4b53acea0dc8b671617a72.svg";